export interface PropertyDef {
  id: string;
  name: string;
  description: string;
  costs: number[];
  tierNames: string[];
  flavorTexts: string[];
}

const HOME_TIER_NAMES = ['', 'Cabin', 'Lodge', 'House', 'Villa', 'Mansion'];
const DOCK_TIER_NAMES = ['', 'Wooden Pier', 'Small Dock', 'Fishing Dock', 'Commercial Pier', 'Grand Marina'];

export const DOCK_PURCHASE_COST = 500;

export const PROPERTY_DEFS: PropertyDef[] = [
  {
    id: 'home',
    name: 'Home',
    description: 'Where you rest between adventures.',
    costs: [0, 750, 8000, 250000, 50000000],
    tierNames: HOME_TIER_NAMES,
    flavorTexts: [
      'A rustic cabin by the shore. Simple but cozy.',
      'A comfortable wooden lodge with a view of the water.',
      'A proper house with sturdy walls and a fireplace.',
      'A grand villa overlooking the harbor with marble floors.',
      'A sprawling mansion with servant quarters and a private dock.',
    ],
  },
  {
    id: 'dock',
    name: 'Dock',
    description: 'Your private berth for vessels. Each tier adds +1 to your vessel cap.',
    costs: [0, 500, 5000, 50000, 500000],
    tierNames: DOCK_TIER_NAMES,
    flavorTexts: [
      'A leaning wooden post you tie your boat to.',
      'A modest wooden pier with room for a small vessel.',
      'A sturdy fishing dock with cleats and a bait shed.',
      'A commercial-grade pier with crane access and storage.',
      'A grand marina with berths for an entire fleet.',
    ],
  },
];

export function getPropertyDefById(id: string): PropertyDef | undefined {
  return PROPERTY_DEFS.find(p => p.id === id);
}

export function getPropertyTierName(id: string, tier: number): string {
  if (tier < 1 || tier > 5) return 'Unknown';
  const def = getPropertyDefById(id);
  if (!def) return `Tier ${tier}`;
  return def.tierNames[tier] || `Tier ${tier}`;
}

export function getPropertyUpgradeCost(id: string, currentTier: number): number | null {
  const def = getPropertyDefById(id);
  if (!def) return null;
  if (currentTier >= 5) return null;
  return def.costs[currentTier];
}

export function getHomeFlavorText(tier: number): string {
  const def = getPropertyDefById('home');
  if (!def) return 'A modest cottage by the shore.';
  const idx = Math.max(0, Math.min(tier - 1, def.flavorTexts.length - 1));
  return def.flavorTexts[idx];
}

export function getDockFlavorText(tier: number): string {
  const def = getPropertyDefById('dock');
  if (!def) return 'A simple dock.';
  const idx = Math.max(0, Math.min(tier - 1, def.flavorTexts.length - 1));
  return def.flavorTexts[idx];
}
